import React, { useState, useEffect } from 'react';
import { Form, Input, Select, BackTop } from 'antd';
import { useTranslation } from 'react-i18next';
import IconEmailTemplate from '../../../../assets/Images/icons/icon-email-template';
import IconEmailTemplateRight from '../../../../assets/Images/icons/icon-email-template-right';
import IconWhiteFactLogo from '../../../../assets/Images/icons/icon-email-template-logo';
import IconEmailTemplatActive from '../../../../assets/Images/icons/icon-email-template-active';
import moment from 'moment';

export default function TemplateEmail2({
    form,
    dsFormData,
    detail,
    emailList,
}) {
    const { t, i18n } = useTranslation();
    let lang = i18n.language;

    const { TextArea } = Input;

    const [selectedItems, setSelectedItems] = useState([]);
    const [proofOfIdentityList, setProofOfIdentityList] = useState([]);
    const filteredOptions = emailList?.filter(
        (o) => !selectedItems?.includes(o)
    );

    useEffect(() => {
        if (emailList?.length > 0) {
            setSelectedItems(emailList);
            form.setFieldsValue({
                assignTo: emailList,
                operatorRemark:
                    'โปรดตรวจสอบรายละเอียดคำขอใช้สิทธิก่อนกดยืนยันรับงาน เมื่อรับงานแล้วโปรดดำเนินการต่อไป',
            });
        }
        if (dsFormData) {
            const proofOfIdentity =
                dsFormData?.evidenceInformation?.proofOfIdentity?.filter(
                    (e) => e?.id !== '0ecb41743d7111edb8780242ac120002'
                );
            setProofOfIdentityList(proofOfIdentity);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [emailList, dsFormData]);

    return (
        <>
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            <div className="col-span-1 bg-white h-max rounded-t-lg">
                <div
                    className="px-8 py-4 text-[#7B67FB] text-[16px] font-semibold"
                    style={{ borderBottom: '1px solid #ECECEC' }}
                >
                    อีเมลส่งถึงผู้รับผิดชอบในขั้นตอนต่อไป
                </div>
                <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-12 px-8">
                        <Form.Item
                            name={'assignTo'}
                            className="mt-2 mb-2"
                            label={
                                <span className="text-[14px] text-[#65707A] text-left">
                                    {t('to')}
                                </span>
                            }
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Select
                                mode="multiple"
                                placeholder={t('MyTask.PleaseSelect')}
                                value={selectedItems}
                                onChange={setSelectedItems}
                                style={{
                                    width: '77%',
                                }}
                            >
                                {filteredOptions?.map((item) => (
                                    <Select.Option key={item} value={item}>
                                        {item}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <div className="flex justify-between">
                            <div className="text-[14px] text-[#65707A]">
                                cc : -
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="px-44 py-14 text-[16px] bg-[#ECECEC] rounded-b-lg mb-4">
                <div className="text-center my-2">
                    <IconWhiteFactLogo />
                </div>
                <div className="p-8 text-[16px] bg-white rounded-lg">
                    <div className="text-[14px] font-semibold">
                        โปรดดำเนินการ
                        <span className="text-[#1890FF]">
                            {' '}
                            {lang === 'en'
                                ? detail?.workflowNextStepNameEn || '-'
                                : detail?.workflowNextStepNameTh || '-'}{' '}
                        </span>
                    </div>
                    <div className="text-[14px] font-semibold">
                        การดำเนินการตามคำร้องควรเสร็จสิ้นภายในวันที่
                        <span className="text-[#1890FF]">
                            {' '}
                            {detail?.dueDate
                                ? moment(detail?.dueDate).format('DD/MM/YYYY')
                                : '-'}{' '}
                        </span>{' '}
                        (คงเหลือ{' '}
                        <span className="text-[#1890FF]">
                            {' '}
                            {detail?.dayLeft || '-'}{' '}
                        </span>{' '}
                        วัน)
                    </div>
                    <div className="text-[14px] font-semibold my-4">
                        รายละเอียดคำขอใช้สิทธิ
                    </div>

                    <div className="text-[14px] font-semibold">
                        หมายเลขติดตามคำขอใช้สิทธินี้ :{' '}
                        <span className="font-normal text-[#464E5F]">
                            {detail?.requestId || '-'}
                        </span>
                    </div>
                    <div className="text-[14px] font-semibold">
                        เปิดคำขอใช้สิทธิเมื่อวันที่ :{' '}
                        <span className="font-normal text-[#464E5F]">
                            {detail?.requestDate
                                ? moment(detail?.requestDate).format(
                                      'DD/MM/YYYY'
                                  )
                                : '-'}{' '}
                        </span>
                    </div>
                    <div className="text-[14px] font-semibold">
                        ชื่อเจ้าของข้อมูล :{' '}
                        <span className="font-normal text-[#464E5F]">
                            {dsFormData?.dataSubjectInformation?.firstName
                                ? `${dsFormData?.dataSubjectInformation?.firstName} ${dsFormData?.dataSubjectInformation?.lastName}`
                                : '-'}
                        </span>
                    </div>
                    <div className="text-[14px] font-semibold">
                        ตัวแทนในการยื่นคำร้อง :{' '}
                        <span className="font-normal text-[#464E5F]">
                            {dsFormData?.applicantInformation?.firstName
                                ? `${dsFormData?.applicantInformation?.firstName} ${dsFormData?.applicantInformation?.lastName}`
                                : '-'}
                        </span>
                    </div>
                    <div className="text-[14px] font-semibold">
                        ประเภทเจ้าของข้อมูล :{' '}
                        <span className="font-normal text-[#464E5F]">
                            {lang === 'en'
                                ? dsFormData?.dataSubjectInformation
                                      ?.dataSubjectNameEn || '-'
                                : dsFormData?.dataSubjectInformation
                                      ?.dataSubjectNameTh || '-'}
                        </span>
                    </div>
                    <div className="text-[14px] font-semibold">
                        ประเภทการขอใช้สิทธิ :{' '}
                        <span className="font-normal text-[#464E5F]">
                            {lang === 'en'
                                ? dsFormData?.detailsOfClaim
                                      ?.requestTypeShortName || '-'
                                : dsFormData?.detailsOfClaim
                                      ?.requestTypeShortName || '-'}
                        </span>
                    </div>

                    <div className="text-[14px] font-semibold mt-4 mb-1">
                        ข้อมูลส่วนบุคคลที่ประสงค์จะใช้สิทธิ
                    </div>
                    <div className="text-[14px] font-normal text-[#464E5F] whitespace-pre-line">
                        {dsFormData?.detailsOfClaim?.purpose || '-'}
                    </div>

                    <div className="text-[14px] font-semibold mt-4 mb-1">
                        รายละเอียดการขอใช้สิทธิและเหตุผลในการขอ
                    </div>
                    <div className="text-[14px] font-normal text-[#464E5F] whitespace-pre-line">
                        {dsFormData?.detailsOfClaim?.reason || '-'}
                    </div>

                    <div className="text-[14px] font-semibold mt-4 mb-1">
                        หลักฐานประกอบคำขอใช้สิทธิ
                    </div>
                    <div className="text-[14px] font-normal text-[#464E5F]">
                        {dsFormData?.evidenceInformation?.evidence
                            ? 'มีการแนบ'
                            : 'ไม่มีการแนบ'}
                    </div>

                    <div className="text-[14px] font-semibold mt-4 mb-1">
                        หลักฐานยืนยันตัวตน
                    </div>
                    {proofOfIdentityList?.length > 0 ? (
                        <>
                            {proofOfIdentityList?.map((e) => (
                                <>
                                    <div className="text-[14px] font-normal text-[#464E5F] ml-2">
                                        &#8226; {e?.name}
                                    </div>
                                </>
                            ))}
                        </>
                    ) : (
                        <></>
                    )}
                    {dsFormData?.evidenceInformation?.proofOfIdentityAddon ? (
                        <div className="text-[14px] font-normal text-[#464E5F] ml-2">
                            &#8226;{' '}
                            {
                                dsFormData?.evidenceInformation
                                    ?.proofOfIdentityAddon
                            }
                        </div>
                    ) : (
                        <></>
                    )}

                    <div className="text-[14px] font-semibold mt-4 mb-1">
                        ข้อมูลเพิ่มเติม
                    </div>
                    <Form.Item className="mt-2" name={'operatorRemark'}>
                        <TextArea
                            size="large"
                            className="bg-[#F4F6FC] text-[14px]"
                            autoSize={{ minRows: 3, maxRows: 4 }}
                            placeholder={t('MyTask.DescribeDetails')}
                        />
                    </Form.Item>

                    <div className="text-[14px] font-semibold my-4">
                        ดูรายละเอียดเพิ่มเติมและเริ่มทำงานได้ที่เมนู Data
                        Subject 360 {'>'}{' '}
                        <span className="text-[#7B67FB]">My Task</span>
                    </div>

                    <div
                        className="my-4"
                        style={{ borderBottom: ' 2px solid #F5F6FF' }}
                    ></div>
                    <div className="p-4 text-center text-[12px] text-[#171717]">
                        Copyright © 2022 Whitefact
                    </div>
                </div>
            </div>
            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
